import axios from 'axios';
import { serverDomain } from '../pages/config';

const APP_ICON_COLORS = [
  '#FF6B6B', '#4ECDC4', '#45B7D1', '#FFA07A', '#98D8C8',
  '#F7DC6F', '#BB8FCE', '#85C1E2', '#F8B739', '#52B788',
  '#E63946', '#F77F00', '#06FFC5', '#118AB2', '#073B4C',
  '#9D4EDD', '#FF006E', '#8338EC', '#3A86FF', '#FB5607',
  '#EF476F', '#06D6A0', '#FFD166', '#26547C', '#00AFB9'
];

const randomColor = () => APP_ICON_COLORS[Math.floor(Math.random() * APP_ICON_COLORS.length)];

const isLightColor = (hex) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.5;
};

export const generateRandomAppIconStyle = () => {
  const styleType = Math.floor(Math.random() * 6) + 1;
  let background = '';
  let colors = [];

  switch (styleType) {
    case 1:
      colors = [randomColor()];
      background = colors[0];
      break;
    case 2:
      colors = [randomColor(), randomColor()];
      background = `linear-gradient(to right, ${colors[0]}, ${colors[1]})`;
      break;
    case 3:
      colors = [randomColor(), randomColor()];
      background = `linear-gradient(to bottom, ${colors[0]}, ${colors[1]})`;
      break;
    case 4:
      colors = [randomColor(), randomColor()];
      background = `linear-gradient(135deg, ${colors[0]}, ${colors[1]})`;
      break;
    case 5:
      colors = [randomColor(), randomColor()];
      background = `linear-gradient(225deg, ${colors[0]}, ${colors[1]})`;
      break;
    case 6:
      colors = [randomColor(), randomColor(), randomColor(), randomColor()];
      background = `linear-gradient(135deg, ${colors[0]} 0%, ${colors[1]} 33%, ${colors[2]} 66%, ${colors[3]} 100%)`;
      break;
    default:
      colors = [randomColor()];
      background = colors[0];
  }

  const textColor = isLightColor(colors[0]) ? '#000000' : '#FFFFFF';
  return JSON.stringify({ background, textColor });
};

export const createNewAppRequest = (token) => {
  if (!token) {
    return Promise.reject(new Error('Missing token'));
  }

  return axios
    .post(serverDomain + 'create_new_app.php', null, {
      params: {
        token,
        action: 'create',
        icon_style: generateRandomAppIconStyle()
      }
    })
    .then((response) => {
      if (response?.data?.success === 1) {
        return response.data;
      }

      const error = new Error(response?.data?.error || response?.data?.message || 'App could not be created at the moment');
      error.response = response;
      throw error;
    });
};

export const setCurrentAppContext = ({ appId, appName }) => {
  localStorage.setItem('appstar_app_id', appId);
  localStorage.setItem('appstar_app_name', appName);

  window.dispatchEvent(new CustomEvent('appstar:app-selected', {
    detail: {
      appId: String(appId || ''),
      appName: String(appName || '')
    }
  }));
};
